module.exports = __webpack_public_path__ + "static/media/ibd_arm2.53163657.png";